import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { IsMobile } from "utils/is-mobile";

export default function CartButton({ onClick, totalItems, brandColors }) {
  const mobile = IsMobile();

  return (
    <button
      onClick={onClick}
      style={{
        position: "fixed",
        bottom: mobile ? "24px" : "32px",
        right: mobile ? "24px" : "32px",
        backgroundColor: brandColors.primary,
        color: "white",
        width: mobile ? "64px" : "72px",
        height: mobile ? "64px" : "72px",
        borderRadius: "9999px",
        boxShadow:
          "0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1199,
        border: "none",
        cursor: "pointer",
        transition: "transform 0.2s, box-shadow 0.2s",
      }}
      onMouseEnter={(e) => {
        e.target.style.transform = "scale(1.05)";
        e.target.style.boxShadow =
          "0 12px 20px -3px rgba(0,0,0,0.15), 0 6px 8px -2px rgba(0,0,0,0.1)";
      }}
      onMouseLeave={(e) => {
        e.target.style.transform = "scale(1)";
        e.target.style.boxShadow =
          "0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)";
      }}
    >
      <ShoppingCartIcon style={{ fontSize: mobile ? "32px" : "36px" }} />
      {totalItems > 0 && (
        <span
          style={{
            position: "absolute",
            top: "-4px",
            right: "-4px",
            backgroundColor: "#ef4444",
            color: "white",
            fontSize: mobile ? "12px" : "14px",
            fontWeight: "bold",
            borderRadius: "9999px",
            minWidth: mobile ? "24px" : "28px",
            height: mobile ? "24px" : "28px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: totalItems > 9 ? "0 6px" : "0",
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
          }}
        >
          {totalItems > 99 ? "99+" : totalItems}
        </span>
      )}
    </button>
  );
}
